import { User } from '@nextforce/api'
import { AvatarProps, makeStyles } from '@rneui/themed'
import { times } from 'lodash'
import React from 'react'
import { View } from 'react-native'
import { DEFAULT_USER_PHOTO_URL } from 'users/constants'
import { UserAvatar } from './user_avatar'

interface Props {
  user?: User
  size?: AvatarProps['size']
}

const AVATAR_COUNT = 3

const AVATAR_OFFSET = 5

export function StackedUserAvatars({ user, size }: Props) {
  const styles = useStyles()

  return (
    <View style={styles.container}>
      {times(AVATAR_COUNT, index => (
        <View
          style={[styles.stack, { right: index * AVATAR_OFFSET }]}
          key={String(index)}
        >
          <UserAvatar
            user={
              user && {
                ...user,
                photoUrl: DEFAULT_USER_PHOTO_URL,
                id: String(parseInt(user.id) * index),
              }
            }
            size={size ?? 'small'}
          />
        </View>
      ))}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    marginLeft: AVATAR_OFFSET * 2,
    marginRight: 10,
  },
  stack: {
    position: 'absolute',
    width: '100%',
  },
}))
